import { Inject, Injectable } from '@angular/core';
import { NavigatorProcedureState } from './navigator-procedure.state';
import { ISmartNavigatorService, SMART_NAVIGATOR_SERVICE } from '@ui-tool/core';
import { NavigatorBaseComponentStore } from '../base';
import {
  NavigatorContainerCodes,
  ScreenCodes,
} from '@mobile-data-access-enums';
import { NavController } from '@ionic/angular';

@Injectable()
export class NavigatorProcedureComponentStore extends NavigatorBaseComponentStore<
  NavigatorContainerCodes.PROCEDURE,
  NavigatorProcedureState
> {
  //#region Constructor

  public constructor(
    @Inject(SMART_NAVIGATOR_SERVICE)
    protected override readonly _navigationService: ISmartNavigatorService,
    protected override readonly _navController: NavController
  ) {
    super(
      _navigationService,
      _navController,
      ScreenCodes.CHEMOTHERAPY_PROCEDURE
    );
  }

  //#endregion
}
